import React from "react";
import { Link } from "react-router-dom";
import { Home, Search } from "lucide-react";
import Seo from "@/components/Seo";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="ca-container py-24 text-center max-w-lg" data-testid="not-found-page">
      <Seo title="Page Not Found | ComplaintAdvisor" description="The page you are looking for could not be found." noindex />
      <p className="font-display text-7xl font-extrabold text-teal">404</p>
      <h1 className="font-display text-2xl font-bold text-slate-900 mt-2">Page not found</h1>
      <p className="text-slate-600 mt-2">The page you are looking for may have moved or no longer exists.</p>
      <div className="mt-6 flex gap-3 justify-center">
        <Link to="/"><Button className="bg-teal-brand hover:bg-teal-700 text-white"><Home className="h-4 w-4 mr-1" /> Home</Button></Link>
        <Link to="/vendors"><Button variant="outline"><Search className="h-4 w-4 mr-1" /> Browse vendors</Button></Link>
      </div>
    </div>
  );
}
